String.prototype.validateTel = function () {
  const val = this.valueOf();
  if (val && val.length < 7) return '這不是正確的電話格式';
  else return '';
};

String.prototype.validateAdd = function () {
  const val = this.valueOf();
  if (val && this.toString().length <= 2) return '這不是正確的地址格式';
  else return '';
};

String.prototype.validateTime = function () {
  const val = this.valueOf();
  const time = new Date().toLocaleTimeString('en-GB');
  if (val && val < time) return '無法選擇過去時間';
  else return '';
};

String.prototype.validateMobileCarrier = function () {
  const val = this.valueOf();
  const regex = /^\/[A-Za-z0-9+-.]{7}$/i;
  if (!regex.test(val)) return '錯誤輸入:/+[英數字+-.]7碼，共8碼';
  else return '';
};

String.prototype.validateCitizenCarrier = function () {
  const val = this.valueOf();
  const regex = /^[a-zA-Z]{2}[0-9]{14}$/;
  if (!regex.test(val)) return '錯誤輸入:[2碼英文字母]+[14碼數字]，共16碼';
  else return '';
};

String.prototype.validateTextLimit = function (require = false, limit = 10000) {
  //val要驗證的值 ; require-是不是必填 ; limit-限制的字數
  const val = this.valueOf();
  if (require) {
    if (!val) return '此為必填';
    else if (val.length > limit) return `字數超過限制，限${limit}字以內`;
    else return '';
  } else {
    if (val && val.length > limit) return `字數超過限制，限${limit}字以內`;
    else return '';
  }
};
